import React from 'react';
import {
  FORM_FIELDS,
  FORM_FIELDS_NAMES,
  IApplicationDetails
} from '../../constants/new-application/new-application-form';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';

interface Props {
  formik: FormikProps<IApplicationDetails>;
  formEditStatus: boolean;
}

const PCICheckbox = (props: Props): React.ReactElement => {
  const { formik, formEditStatus } = props;
  const { t } = useTranslation();

  return (
    <div className="col-6 col-sm-4 col-md-3 fv-row">
      <div className="form-check fw-bold col-md-12 mt-7">
        <input
          type="checkbox"
          className="form-check-input"
          style={{
            width: 23,
            height: 23
          }}
          disabled={!formEditStatus}
          checked={formik.values[FORM_FIELDS.PCI_DSS] as boolean}
          {...formik.getFieldProps(FORM_FIELDS.PCI_DSS)}
        />
        <label className="form-check-label">{t(FORM_FIELDS_NAMES.PCI_DSS)}</label>
      </div>
      {formik.touched[FORM_FIELDS.PCI_DSS] && formik.errors[FORM_FIELDS.PCI_DSS] && (
        <div className="fv-plugins-message-container text-danger">
          <div className="fv-help-block">{formik.errors[FORM_FIELDS.PCI_DSS]}</div>
        </div>
      )}
    </div>
  );
};

export default PCICheckbox;
